import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'hasThresholds', standalone: true })
export class HasThresholdsPipe implements PipeTransform {
  transform(egwsummerProducts: any[]): boolean {
    return (
      egwsummerProducts.some(p => !!p['productData']['info']) ||
      egwsummerProducts.some(p => !!p['productData']['nowcast']) ||
      egwsummerProducts.some(p => !!p['productData']['heavyRainWarning']) ||
      egwsummerProducts.some(p => !!p['productData']['precipitationWarning']) ||
      egwsummerProducts.some(p => !!p['productData']['windWarning'])
    );
  }
}
